import logo from './logo.svg';
import './App.css';

import { useEffect, useState } from 'react';
import ImageBackgroundRemover from "./ImageHandle";
function App() {
  return(
<div>
  <ImageBackgroundRemover/>
</div>
  )
}
export default App;
